module.exports = __webpack_public_path__ + "5446e30c0d872de58dbb4f4ac96a04cf.svg";